import {ApplicationConfig, importProvidersFrom, LOCALE_ID, provideZoneChangeDetection} from '@angular/core';
import {provideRouter} from '@angular/router';

import {routes} from './app.routes';
import {LoggerModule, NgxLoggerLevel} from 'ngx-logger';
import {environment} from '../environments/environment';
import {COMPOSITION_BUFFER_MODE} from '@angular/forms';
import {provideHttpClient, withInterceptors} from '@angular/common/http';
import {credentialsInterceptor} from './core/interceptors/credentials.interceptor';
import {authRefreshInterceptor} from './core/interceptors/auth-refresh.interceptor';

// TODO 기본 설정을 하는 곳
//  1. 라이브러리나 디자인의 기본 설정을 변경하면 전역적으로 적용됨
export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({eventCoalescing: true}),
    provideRouter(routes),
    provideHttpClient(withInterceptors([credentialsInterceptor, authRefreshInterceptor])),
    importProvidersFrom(
      LoggerModule.forRoot({
        level: environment.production ? NgxLoggerLevel.OFF : NgxLoggerLevel.DEBUG
      })
    ),
    {provide: LOCALE_ID, useValue: 'ko'},
    {provide: COMPOSITION_BUFFER_MODE, useValue: false},
    {provide: 'API_HOST', useValue: environment.apiUrl},
  ]
};

